var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFrLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circleClipFR"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2182 0.613281C7.46875 0.613281 0.613281 7.46875 0.613281 16.2182C0.613281 24.9688 7.46875 31.8242 16.2182 31.8242C24.9688 31.8242 31.8242 24.9688 31.8242 16.2182C31.8242 7.46875 24.9688 0.613281 16.2182 0.613281Z",
    fill: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circleClipFR)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.613281,
    y: 0.613281,
    width: 10,
    height: 31.2109,
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6133,
    y: 0.613281,
    width: 11.2109,
    height: 31.2109,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.8242,
    y: 0.613281,
    width: 10,
    height: 31.2109,
    fill: "#D80027"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFrLanguage);
export default __webpack_public_path__ + "static/media/ic_fr_language.bb6666eec6bfa59a673224d9f904b062.svg";
export { ForwardRef as ReactComponent };